import * as React from 'react';

import AdminMultiSelect from 'modules/admin/components/AdminMultiSelect';

import { __t, applyTranslations } from 'utils/language';

import type { APISimpleDropDownProfileResponse } from 'modules/admin/types/APISimpleDropDownProfileResponse.type';
import type { MultiSelectItem } from 'types';

import './inspirational-materials-campaign-content-filters.scss';

applyTranslations(require('./inspirational-materials-campaign-content-filters.i18n.json'));

type Props = {
  currentCampaignId: number | undefined | null,
  campaigns: Array<APISimpleDropDownProfileResponse>,
  onChange: (a?: number | null) => void
};

const InspirationalMaterialsCampaignContentFilters = (
  {
    campaigns,
    currentCampaignId,
    onChange
  }: Props
): JSX.Element => {
  const mappedItems: Array<MultiSelectItem> = campaigns.map(item => ({
    value: String(item.id),
    label: item.name
  }));

  return (
    <section className="inspirational-materials-campaign-content-filters">
      <AdminMultiSelect
        name="campaignId"
        placeholder={__t('inspirational_materials_campaign_content_filters.filter_placeholder')}
        items={mappedItems}
        value={String(currentCampaignId)}
        onChange={(id?: string | null) => {
          onChange((id) ? Number(id) : undefined);
        }}
      />
    </section>
  );
};

export default InspirationalMaterialsCampaignContentFilters;
